import {
  FormLayout,
  Panel,
  PanelSection,
  PanelHeader,
  PanelTitle,
  PanelDescription,
} from '@customerio/pluma-components/react';
import { withForm } from '@/components/form';
import { aiBusinessProfileFormOptions } from '../helpers/form';
import { KeyLinksFields } from '@/features/business-profile-forms';

export const KeyLinksInfo = withForm({
  ...aiBusinessProfileFormOptions,
  props: {
    canEdit: true,
  },
  render: function KeyLinksInfo({ form, canEdit }) {
    return (
      <Panel>
        <PanelHeader>
          <PanelTitle>Key links</PanelTitle>
          <PanelDescription>AI features can reference these links when needed in generating content</PanelDescription>
        </PanelHeader>
        <PanelSection>
          <FormLayout>
            <KeyLinksFields form={form} isDisabled={canEdit === false} />
          </FormLayout>
        </PanelSection>
      </Panel>
    );
  },
});
